"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.residenceStatusesList = void 0;
exports.residenceStatusesList = [
    {
        label: "Citizen",
        value: "01",
    },
    {
        label: "Permanent resident",
        value: "02",
    },
    {
        label: "Visitor",
        value: "03",
    },
    {
        label: "Worker",
        value: "04",
    },
    {
        label: "Student",
        value: "05",
    },
    {
        label: "Other",
        value: "06",
    },
    {
        label: "Protected Person",
        value: "07",
    },
    {
        label: "Refugee Claimant",
        value: "08",
    },
    {
        label: "Foreign National",
        value: "09",
    },
];
